module.exports = __webpack_public_path__ + "static/media/mpms3_sampleProbe_cropped.39961eca.png";